import React, { useEffect, useState } from 'react';
import { request } from '@/fetch/core';
import { HttpStatusCode } from '@/fetch/core/constant';
import { Method } from '@/fetch/core/util';
import './index.scss';
const BindVehicleList = (props: { cockpitNumber: string }) => {
  const [vehicleList, setVehicleList] = useState<any>([]);
  const getVehicleList = () => {
    request({
      path: '/k2/management/monitor/cockpit/get_vehicle_list',
      method: Method.POST,
      body: {
        cockpitNumber: props.cockpitNumber,
      },
    }).then((res) => {
      if (res.code === HttpStatusCode.Success) {
        const vehicleMap = new Map([]);
        const vehicleList = [];
        res?.data
          ?.filter((i: any) => i.stationName)
          .forEach((item: any) => {
            const { stationName, deviceName } = item;
            const value: any = vehicleMap.get(stationName);
            if (value) {
              value?.push(deviceName);
            } else {
              vehicleMap.set(stationName, [deviceName]);
            }
          });
        for (const [key, value] of vehicleMap.entries() as any) {
          vehicleList.push({
            id: key,
            name: key,
            children: value?.map((i: string) => ({
              id: i,
              name: i,
            })),
          });
        }
        setVehicleList(vehicleList);
      }
    });
  };

  const renderVehicleList = () => {
    return vehicleList?.map((item: any) => {
      return (
        <div className="second-level" key={item.id}>
          <div className="label">{item.name}</div>
          <ul className="vehicle-list">
            {item?.children?.map((i: any) => (
              <i key={i.id}>
                {i.name}
              </i>
            ))}
          </ul>
        </div>
      );
    });
  };
  useEffect(() => {
    getVehicleList();
  }, []);
  return <div className="bind-vehicle-list">{renderVehicleList()}</div>;
};

export default BindVehicleList;
